export default "__VITE_ASSET__E4XZ21ux__"